module.exports = __webpack_public_path__ + "static/media/cards.c4042542.svg";